export const ShipDateGroupsEnum = Object.freeze({
    GROUP_1_TO_7: "1-7 Days",
    GROUP_8_TO_30: "8-30 Days",
    GROUP_61_PLUS: "61+ Days",
    NO_SHIP_DATE: "No ship date set",
    SHIPPED: "Ship Date passed",
});
